export default "__VITE_ASSET__qoYKLbO7__"